import { render, staticRenderFns } from "./AdminUserSubMenusLinks.vue?vue&type=template&id=4b6b5cac"
import script from "./AdminUserSubMenusLinks.vue?vue&type=script&lang=js"
export * from "./AdminUserSubMenusLinks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b6b5cac')) {
      api.createRecord('4b6b5cac', component.options)
    } else {
      api.reload('4b6b5cac', component.options)
    }
    module.hot.accept("./AdminUserSubMenusLinks.vue?vue&type=template&id=4b6b5cac", function () {
      api.rerender('4b6b5cac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/menu/sub-menus/users/AdminUserSubMenusLinks.vue"
export default component.exports